<template>
    <div class="login-container">
        <div class="login-box">
            <!-- 左侧插图区域 -->
            <div class="login-illustration">
                <div class="logo">
                    <img src="../assets/logo.png" alt="博亿购" />
                </div>
            </div>
            <!-- 右侧重置密码表单区域 -->
            <div class="login-form">
                <h2 class="login-title">重置密码!</h2>
                <!-- 重置密码表单 -->
                <el-form :model="passwordForm" ref="passwordForm" class="form" :rules="registerRules">
                    <el-form-item prop="phone">
                        <el-input v-model="passwordForm.phone" placeholder="请输入手机号" size="large"
                            prefix-icon="el-icon-mobile" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item prop="verifyCode">
                        <el-input v-model="passwordForm.verifyCode" placeholder="验证码" size="large"
                            prefix-icon="el-icon-message" maxlength="4">
                            <template slot="append">
                                <get-verify-code :phone="passwordForm.phone" code-type="2"></get-verify-code>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="passwordForm.password" :type="passwordType" placeholder="密码" size="large"
                            prefix-icon="el-icon-lock" maxlength="12"></el-input>
                        <img src="~@/assets/images/60.png" alt="隐藏密码" v-if="passwordType == 'password'" class="show-pwd"
                            @click="showPwd" />
                        <img src="~@/assets/images/61.png" alt="显示密码" v-else class="show-pwd" @click="showPwd" />
                    </el-form-item>
                    <el-form-item prop="confirmPassword">
                        <el-input v-model="passwordForm.confirmPassword" :type="passwordType" placeholder="确认密码"
                            size="large" prefix-icon="el-icon-lock" maxlength="12"></el-input>
                        <img src="~@/assets/images/60.png" alt="隐藏密码" v-if="passwordType == 'password'" class="show-pwd"
                            @click="showPwd" />
                        <img src="~@/assets/images/61.png" alt="显示密码" v-else class="show-pwd" @click="showPwd" />
                    </el-form-item>
                    <div class="form-actions">
                        <el-link type="primary" class="forgot-link" :underline="false">
                            <router-link to="/login">已有账号？立即登录</router-link>
                        </el-link>
                    </div>
                    <el-button type="primary" @click="handleResetPassword" size="large" class="login-button" block>
                        确定
                    </el-button>
                </el-form>
            </div>
        </div>
        <!-- 版权信息 -->
        <div class="copyright">
            Copyright©2023 盐城搏亿能源科技发展有限公司 备案号：{{systemParams.app_icp}}
        </div>
    </div>
</template>

<script>
import { phoneRules, passwordRules } from '../utils/validate'
import GetVerifyCode from '../components/GetVerifyCode.vue'
export default {
    name: 'ForgetPassword',
    components: {
        GetVerifyCode
    },
    data() {
        return {
            systemParams: {},
            timer: null, // 计时器,@Function
            time: 60, // 倒计时60S,@Number
            beginning: false, // 显示倒计时,@Boolean
            passwordForm: {
                phone: '',
                verifyCode: '',
                password: '',
                confirmPassword: '',
            },
            // 密码登录表单验证规则
            registerRules: {
                phone: phoneRules(),
                verifyCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                password: passwordRules(),
                confirmPassword: [
                    ...passwordRules(), // 复用密码格式验证
                    {
                        validator: (rule, value, callback) => {
                            // 验证两次输入的密码是否一致
                            if (value !== this.passwordForm.password) {
                                callback(new Error('两次输入的密码不一致'));
                            } else {
                                callback(); // 验证通过
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            passwordType: 'password',
        }
    },
    mounted() {
        this.getSystemParams();
    },
    methods: {
        getSystemParams() {
            this.$api.getSystemParams({}).then(res => {
                this.systemParams = res;
            }).catch(err => {
                this.$message.error(err);
            })
        },
        showPwd() {
            this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
        },
        handleResetPassword() {
            this.$refs.passwordForm.validate((valid) => {
                if (valid) {
                    this.$api.changePassword({
                        password: this.passwordForm.password,
                        account: this.passwordForm.phone,
                        code: this.passwordForm.verifyCode,
                        account_type: 'mobile',
                        type: '2',
                    }).then(res => {
                        this.$message.success('修改成功');
                        this.$router.push('/login');
                    }).catch(err => {
                        this.$message.error(err);
                    })
                }
            })
        },
    },
}
</script>

<style scoped>
.login-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    /* 使用渐变背景 */
    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
    /* 也可以使用背景图片 */
    background-image: url('../assets/images/4.png');
    /* background-size: cover; */
    /* background-position: center; */
    /* background-repeat: no-repeat; */
}

.login-box {
    display: flex;
    width: 1082px;
    height: 608px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

/* 左侧插图区域 */
.login-illustration {
    position: relative;
    width: 596px;
    height: 608px;
    background-image: url('../assets/images/3.png');
    background-size: cover;
    /* background-position: center; */
}

.logo {
    position: absolute;
    top: 28px;
    left: 47px;
}

.logo img {
    /* width: 156px; */
    height: 80px;
}

/* 右侧注册表单区域 */
.login-form {
    flex: 1;
    padding: 50px 40px;
    display: flex;
    flex-direction: column;
}

.login-title {
    font-size: 20px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 30px;
}

/* 表单样式 */
.form {
    width: 100%;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 30px;
}

.remember-checkbox {
    color: #666;
    font-size: 14px;
}

.forgot-link {
    font-size: 14px;
    color: #286CED;
}

.login-button {
    height: 40px;
    font-size: 16px;
    font-weight: bold;
    border-color: #286CED;
    margin-bottom: 20px;
    width: 390px;
    height: 48px;
    background: #286CED;
    border-radius: 8px 8px 8px 8px;
}

.login-button:hover {
    background-color: #2158c7;
    border-color: #2158c7;
}

/* 协议部分 */
.agreement {
    font-size: 12px;
    color: #666;
    margin-top: 10px;
}

.agreement .el-checkbox__label {
    color: #666;
    font-size: 12px;
}

.el-link.el-link--primary {
    color: #286CED;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #286CED;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #286CED;
    border-color: #286CED;
}

.copyright {
    font-weight: 400;
    font-size: 14px;
    color: #10357B;
    margin-top: 168px;
}

.show-pwd {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    user-select: none;
    width: 24px;
    height: 24PX;
}
</style>